import { useMemo } from "react";
import {
  InternalAdminOrganizationListInput,
  InternalAdminOrganizationListQuery,
  InternalAdminOrganizationListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_ORGANIZATION_LIST_QUERY from "../_networking/internal-admin-organization-list";

interface IProps {
  input: InternalAdminOrganizationListInput;
}

const useInternalAdminOrganizationList = ({ input }: IProps) => {
  const { data, loading, refetch } = useQuery<
    InternalAdminOrganizationListQuery,
    InternalAdminOrganizationListQueryVariables
  >(INTERNAL_ADMIN_ORGANIZATION_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      input,
    },
  });

  const organizations = useMemo(() => {
    if (!data) return [];
    return data.internalAdminOrganizationList;
  }, [data]);

  return {
    organizations,
    loading,
    refetch,
  };
};

export default useInternalAdminOrganizationList;
